import ApiService from '@common/lib/api/api.service';
import { stringify } from 'query-string';

export const getDevices = params => {
  return ApiService.query(`xeronote/device?${stringify(params)}`);
};

export const getDivMonth = params => {
  return ApiService.query(`xeronote/divMonth?${stringify(params)}`);
};

export const getPlans = params => {
  return ApiService.query(`xeronote/plan?${stringify(params)}`);
};

export const getTelecoms = params => {
  return ApiService.query(`xeronote/telecom?${stringify(params)}`);
};

export const getNickname = params => {
  return ApiService.query(`xeronote/nickname?${stringify(params)}`);
};
